import { Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import { requiredFieldValidation } from "../../../helperFunctions/validation";
import {
	resetValue,
	setData,
	setForm,
} from "../../../redux/slices/StaffFormsSlices";
import TimePicker from "react-bootstrap-time-picker";
import ClickAwayListener from "@mui/base/ClickAwayListener";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useEffect, useMemo, useState } from "react";
import { editWaiting } from "../../../apis/waiting";
import DateInput from "../../SharedComponents/DateInput";

export default function AddEditWaitingList() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { waitingListForm } = useSelector((state) => state.staffForm);
	const [showED, setShowED] = useState(false);
	const [holidayDates, setHolidayDates] = useState([])

	const onFormChange = (e) => {
		const { value, name } = e.target;
		dispatch(setForm({ parent: "waitingListForm", child: name, value }));
	};
	const handleClickAway1 = () => {
		setShowED(false);
	};

	const getListOfHolidays = async () => {
		const { result, error } = await authorizedRequests({
			url: "holidays/listOfHolidays",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "", "error");
			return;
		}
		const dates = result.data?.map((d) => { return new Date(d.eventDate) })
		setHolidayDates(dates)
	}

	const shouldDisabledDate = (date) => {
		if (!date?.$d) {
			return true;
		}
		if (!(date?.$d instanceof Date && !isNaN(date?.$d))) {
			return true;
		}
		const dates = holidayDates?.some(disabledDate =>
			disabledDate.getDate() === date?.$d?.getDate()
			&& disabledDate.getMonth() === date?.$d?.getMonth()
			&& disabledDate.getFullYear() === date?.$d?.getFullYear()
		);
		return dates;
	};

	const submitForm = async (e) => {
		e.preventDefault();

		const formObj = { ...waitingListForm };
		console.log(formObj);

		delete formObj.formStatus;
		if (formObj.startTime == formObj.endTime) {
			toastify("Time in can't be equal to Time out", "error");
			return;
		}
		const validation = requiredFieldValidation(
			{
				name: "Patient",
				value: formObj.patientName,
			},
			{
				name: "Contact",
				value: formObj.contactNumber,
			},
			{
				name: "End Time",
				value: formObj.endTime,
			},
			{
				name: "Start Time",
				value: formObj.startTime,
			},
			{
				name: "Date",
				value: formObj.date,
			},

			// formObj.endTime,
			// formObj.startTime,
			// formObj.date,
		);
		if (!validation.status) {
			toastify(validation.message, "error");
			return;
		}
		if (formObj?.dataId) {
			const response = await editWaiting({
				...formObj,
			});
			if (response.status !== "Fail") {
				toastify("Updated successfully", "success");
				navigate("/waiting-list");
				return;
			} else {
				toastify(response?.message ?? "Failed to update data", "error");
				return;
			}
		}
		const { result, error } = await authorizedRequests({
			url: "waitingList/createWaitingList",
			method: "post",
			data: formObj,
		});
		if (error) {
			toastify(error.message ?? "Unknown error occured", "error");
			return;
		}
		dispatch(resetValue("waitingListForm"));
		toastify("Added succesfully", "success");

		navigate(-1);
	};
	useMemo(() => {
		if (location?.state?.data) {
			dispatch(
				setData({
					parent: "waitingListForm",
					value: {
						patientName: location?.state?.data?.patientName,
						startTime: location?.state?.data?.startTime,
						endTime: location?.state?.data?.endTime,
						contactNumber: location?.state?.data?.contactNumber,
						remarks: location?.state?.data?.remarks,
						date: location?.state?.data?.date,
						gender: location?.state?.data?.gender,
						dataId: location?.state?.data?.dataId,
						formStatus: "Edit",
					},
				}),
			);
		}
	}, [location?.state?.data]);

	useEffect(() => {
		getListOfHolidays()
	}, [])

	return (
		<>
			<div className="mainHeading px-4">
				<h1>
					<i
						className="fa fa-arrow-left cursor-pointer"
						onClick={() => {
							navigate(-1);
						}}
					></i>
					{`${waitingListForm.formStatus + " "}`}
					Waiting List
				</h1>
			</div>
			<div className="pb-4 px-4">
				<div className="content">
					<div className="addEdit pb-4">
						<div className="row">
							<div>
								<Form.Group className="col-md-6">
									<Form.Label className="black-label-text required">
										Patient Name
									</Form.Label>
									<InputGroup className="mb-3 w-75">
										<Form.Control
											name={"patientName"}
											placeholder="Write..."
											onChange={(e) => {
												onFormChange(e);
											}}
											value={waitingListForm.patientName}
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group className="col-md-6">
									<Form.Label className="black-label-text required">
										Contact
									</Form.Label>
									<InputGroup className="mb-3 w-75">
										<Form.Control
											name={"contactNumber"}
											// type="text"
											placeholder="Write..."
											value={
												waitingListForm.contactNumber
											}
											onChange={(e) => {
												if (!isNaN(e.target.value)) {
													onFormChange(e);
												}
											}}
										/>
									</InputGroup>
								</Form.Group>
								<label>Gender</label>
								<Form.Group className="ms-2">
									<Form.Check
										inline
										name="gender"
										type={"radio"}
										onClick={(e) => {
											onFormChange({
												target: {
													name: "gender",
													value: "Male",
												},
											});
										}}
										checked={
											waitingListForm.gender === "Male"
										}
									/>
									<span
										className="font-400-20"
										style={{ fontSize: "16px" }}
									>
										<b>Male</b>
									</span>
								</Form.Group>
								<Form.Group className="ms-2 mb-3">
									<Form.Check
										inline
										name="gender"
										type={"radio"}
										onClick={(e) => {
											onFormChange({
												target: {
													name: "gender",
													value: "Female",
												},
											});
										}}
										checked={
											waitingListForm.gender === "Female"
										}
									/>
									<span
										className="font-400-20"
										style={{ fontSize: "16px" }}
									>
										<b>Female</b>
									</span>
								</Form.Group>
								
								<Form.Group className=" col-md-6">
									<div className="w-75">
										<label>Date *</label>
										<div className="date align-self-center white cursor-pointer mb-3">
											<div>
												<DateInput
													// background={"#34556f"}
													// calenderClass={"whiteCalender"}
													inputClassName="themeInput"
													value={waitingListForm.date}
													onChange={(newValue) => {
														onFormChange({
															target: {
																name: "date",
																value: newValue,
															},
														});
													}}
													shouldDisableDates={true}
												/>
											</div>
										</div>
									</div>
								</Form.Group>
								{/* <Form.Group className="col-md-6">
									<Form.Label className="black-label-text required">
										Date
									</Form.Label>
									<Form.Control
										type="date"
										name="date"
										// selectedValue={appointmentForm.date}
										className="modalTextField mb-3"
										style={{
											paddingRight: "6px",
											width: "75%",
										}}
										value={waitingListForm.date}
										onChange={(e) => {
											onFormChange(e);
										}}
									/>
								</Form.Group> */}
								<Form.Group className=" col-md-6">
									<Form.Label className="black-label-text required">
										Time Start
									</Form.Label>
									<div
										className="d-flex mb-3 w-75"
									>
										<TimePicker
											start="00:00"
											step={30}
											selectedValue={
												waitingListForm.startTime
											}
											// disabled={appointmentForm.startTime}
											className="modalTextField"
											style={{
												paddingRight: "6px",
												height: "47px",
												border: "1.4px solid #939393",
											}}
											value={waitingListForm.startTime}
											onChange={(e) => {
												let h = Math.floor(e / 3600);
												h = h < 10 ? "0" + h : h;

												let m = Math.floor(
													(e % 3600) / 60,
												);
												m = m < 10 ? "0" + m : m;

												onFormChange({
													target: {
														name: "startTime",
														value: `${h}:${m}`,
													},
												});
											}}
										/>

										<TimePicker
											start="00:00"
											step={30}
											selectedValue={
												waitingListForm.endTime
											}
											// disabled={appointmentForm.startTime}
											className="modalTextField ms-2"
											style={{
												paddingRight: "6px",
												height: "47px",
												border: "1.4px solid #939393",
											}}
											value={waitingListForm.endTime}
											onChange={(e) => {
												let h = Math.floor(e / 3600);
												h = h < 10 ? "0" + h : h;
												let m = Math.floor(
													(e % 3600) / 60,
												);
												m = m < 10 ? "0" + m : m;
												onFormChange({
													target: {
														name: "endTime",
														value: `${h}:${m}`,
													},
												});
											}}
										/>
										{/* <Form.Control
											type="time"
											className="modalTextField"
											name="startTime"
											style={{ paddingRight: "6px" }}
											onChange={(e) => {
												onFormChange(e);
											}}
										/>
										<Form.Control
											type="time"
											name="endTime"
											className="modalTextField ms-2"
											style={{ paddingRight: "6px" }}
											onChange={(e) => {
												onFormChange(e);
											}}
										/> */}
									</div>
								</Form.Group>

								<Form.Group className="col-md-6">
									<Form.Label className="black-label-text">
										Remarks
									</Form.Label>
									<InputGroup className="mb-3 w-75">
										<Form.Control
											name={"remarks"}
											as="textarea"
											style={{ resize: "none" }}
											placeholder="Write..."
											onChange={(e) => {
												onFormChange(e);
											}}
											value={waitingListForm.remarks}
										/>
									</InputGroup>
								</Form.Group>
							</div>
						</div>
						<Button
							className="addItem mt-2"
							style={{ width: "150px" }}
							onClick={submitForm}
						>
							Save
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}
